module.exports = "mutation UpdateApplication($application:UpdateApplicationInput!){updateApplication(application:$application){success}}"